import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import '@/style/main.css'
import 'swiper/css';
import axios from 'axios';
import { ElMessage } from 'element-plus';

axios.defaults.withCredentials = true;

// 需要登录才能访问的API列表
const authRequiredApis = [
    '/api/notifications',
    '/api/my-teams',
    '/api/my-bookTeams',
    '/api/team-members',
    '/api/teams',
    '/api/create-team',
    '/api/create-topic',
    '/api/invite-member',
    '/api/change-member-role',
    '/api/remove-member',
    '/api/transfer-team',
    '/api/upload-avatar',
    '/api/change-password',
];

// 请求拦截器：拦截游客对需要登录的API的访问
axios.interceptors.request.use(
    config => {
        const requestUrl = config.url || '';
        // 检查是否是需要登录的API
        const isAuthRequired = authRequiredApis.some(api => requestUrl.includes(api));

        if (isAuthRequired) {
            // 检查登录状态
            const user = JSON.parse(localStorage.getItem('user') || 'null');
            const isGuest = !user || user.userId === 'guest';

            if (isGuest) {
                // 游客状态，取消请求
                console.log(`[请求拦截] 游客无权访问: ${requestUrl}`);
                return Promise.reject({
                    config,
                    message: '请先登录',
                    isGuestBlocked: true // 标记为游客拦截
                });
            }
        }

        return config;
    },
    err => Promise.reject(err)
);

// 错误类型映射
const errorTypeMap = {
    401: { type: 'warning', message: '登录已过期，请重新登录' },
    403: { type: 'error', message: '没有权限访问该资源' },
    404: { type: 'error', message: '请求的资源不存在' },
    500: { type: 'error', message: '服务器内部错误，请稍后重试' },
    502: { type: 'error', message: '网关错误，请检查网络连接' },
    503: { type: 'error', message: '服务不可用，请稍后重试' },
};

axios.interceptors.response.use(
    res => res,
    err => {
        // 如果是游客拦截的请求，静默失败，不显示任何提示
        if (err.isGuestBlocked) {
            return Promise.reject(err);
        }

        // 获取错误状态码
        const status = err.response?.status;

        // 优化后的错误提示
        if (status) {
            const errorInfo = errorTypeMap[status] || {
                type: 'error',
                message: err.response?.data?.message || '请求失败，请稍后重试'
            };

            ElMessage({
                message: errorInfo.message,
                type: errorInfo.type,
                duration: 3000,
                showClose: true,
                grouping: true, // 相同消息只显示一次
            });

            // 401 特殊处理：登出并跳转
            if (status === 401) {
                store.commit('LOGOUT');
                router.push('/');
            }
        } else if (err.code === 'ECONNABORTED') {
            // 请求超时
            ElMessage.error({
                message: '请求超时，请检查网络连接',
                duration: 3000,
                showClose: true,
            });
        } else if (!err.response) {
            // 网络错误
            ElMessage.error({
                message: '网络连接失败，请检查网络',
                duration: 3000,
                showClose: true,
            });
        }

        return Promise.reject(err);
    }
);

const user = JSON.parse(localStorage.getItem('user'))

if (user) {
    store.commit('SET_USER', user)
}

createApp(App).use(store).use(router).use(ElementPlus, { locale: zhCn }).mount('#app')
